module.exports = __webpack_public_path__ + "static/media/beauty.2a21bb60.jpg";